"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FdmQMAPModule {
}
exports.FdmQMAPModule = FdmQMAPModule;
